import React, { useState } from "react";

function TenureSection({ highlights, categories, departments }) {
  const [activeTooltip, setActiveTooltip] = useState(null);

  if (!departments.length) {
    return (
      <section className="hr-dashboard__card">
        <h2 className="hr-dashboard__section-title">Стаж работы в компании</h2>
        <p className="hr-dashboard__empty-state">Нет данных по стажу</p>
      </section>
    );
  }

  return (
    <section className="hr-dashboard__card">
      <h2 className="hr-dashboard__section-title">Стаж работы в компании</h2>

      {highlights.length > 0 && (
        <div className="hr-dashboard__highlights">
          {highlights.map((item) => (
            <div
              key={item.label}
              className={`hr-dashboard__highlight hr-dashboard__highlight--${item.tone}`}
            >
              <span className="hr-dashboard__highlight-value">{item.percent}%</span>
              <span className="hr-dashboard__highlight-label">{item.label}</span>
            </div>
          ))}
        </div>
      )}

      <div className="hr-dashboard__tenure-chart">
        {departments.map((dept) => (
          <div key={dept.id ?? dept.code} className="hr-dashboard__bar-row">
            <div className="hr-dashboard__bar-label">{dept.name || dept.code}</div>
            <div
              className="hr-dashboard__stacked-bar hr-dashboard__stacked-bar--interactive"
              onMouseEnter={() => setActiveTooltip(dept.code)}
              onMouseLeave={() => setActiveTooltip(null)}
            >
              <div className="hr-dashboard__stacked-bar-inner">
                {categories.map((category) => {
                  const count = dept.breakdown[category.key] || 0;
                  const width = dept.total ? (count / dept.total) * 100 : 0;
                  if (!width) return null;
                  return (
                    <div
                      key={category.key}
                      className="hr-dashboard__stacked-segment"
                      style={{ width: `${width}%`, backgroundColor: category.color }}
                    />
                  );
                })}
              </div>
              {activeTooltip === dept.code && (
                <div className="hr-dashboard__tooltip hr-dashboard__tooltip--wide">
                  <strong>
                    {dept.code} — всего {dept.total} чел.
                  </strong>
                  {categories.map((category) => {
                    const count = dept.breakdown[category.key] || 0;
                    const percent = dept.total
                      ? Math.round((count / dept.total) * 100)
                      : 0;
                    if (!count) return null;
                    return (
                      <div key={category.key} className="hr-dashboard__tooltip-row">
                        <span
                          className="hr-dashboard__tooltip-dot"
                          style={{ backgroundColor: category.color }}
                        />
                        <span>
                          {category.label}: {count} ({percent}%)
                        </span>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>

      <div className="hr-dashboard__legend">
        {categories.map((category) => (
          <div key={category.key} className="hr-dashboard__legend-item">
            <span
              className="hr-dashboard__legend-dot"
              style={{ backgroundColor: category.color }}
            />
            <span>{category.label}</span>
          </div>
        ))}
      </div>
    </section>
  );
}

export default TenureSection;
